import { ChecklistItem } from '../types/ChecklistTypes';

const UNTITLED_FALLBACK = 'Untitled';

export function getItemTitleFallback(item: ChecklistItem): string {
  return item.title || UNTITLED_FALLBACK;
}

export function getItemDisplayTitle(
  item: ChecklistItem,
  headerDraft: string | null = null
): string {
  if (!item.editableHeader) return item.title;
  return (headerDraft ?? item.header) || getItemTitleFallback(item);
}
